export const downloadTextFile = (content: string, filename: string) => {
	const element = document.createElement('a')
	const file = new Blob([content], { type: 'text/plain' })
	element.href = URL.createObjectURL(file)
	element.download = filename
	document.body.appendChild(element) // Required for this to work in FireFox
	element.click()
	document.body.removeChild(element)
}

export const readTextFile = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = () => {
			resolve(reader.result as string)
		}
		reader.onerror = reject
		reader.readAsText(file)
	})
}